import type { Component } from '~/types';
import { fetchMultipleResource, fetchSingleResource } from '~/units/core/managers';
import { fetchBlog, fetchBlogs } from '~/units/blogs/services';
import { RepoStates } from '~/units/core/types';

export const fetchBlogsManager = async (component: Component, keyword: string | null = null) => {
  await fetchMultipleResource(component, fetchBlogs, 'blogsRepo', { keyword });
};

export const fetchBlogManager = async (component: Component, slug: string) => {
  await fetchSingleResource(component, fetchBlog, RepoStates.SINGLE_BLOG_REPO, slug);
};
